var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInteractive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 35,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "M13.25 0.333313H2.75C1.50736 0.333313 0.5 1.34067 0.5 2.58331V9.33331C0.5 10.576 1.50736 11.5833 2.75 11.5833H3.75C4.06476 11.5833 4.36115 11.4351 4.55 11.1833L7.2 7.64998C7.6 7.11665 8.4 7.11665 8.8 7.64998L11.45 11.1833C11.6389 11.4351 11.9352 11.5833 12.25 11.5833H13.25C14.4926 11.5833 15.5 10.576 15.5 9.33331V2.58331C15.5 1.34067 14.4926 0.333313 13.25 0.333313Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "M10.6679 14.5H5.33472C5.21402 14.5 5.09559 14.464 4.99205 14.396C4.88851 14.3279 4.80375 14.2303 4.74682 14.1135C4.68988 13.9967 4.6629 13.8651 4.66875 13.7328C4.67461 13.6005 4.71308 13.4724 4.78007 13.3622L7.44665 8.97199C7.51107 8.87722 7.59475 8.80026 7.69104 8.74725C7.78734 8.69423 7.89357 8.66663 8.0013 8.66663C8.10903 8.66663 8.21527 8.69423 8.31156 8.74725C8.40785 8.80026 8.49154 8.87722 8.55595 8.97199L11.2225 13.3622C11.2895 13.4724 11.328 13.6005 11.3338 13.7328C11.3397 13.8651 11.3127 13.9967 11.2558 14.1135C11.1988 14.2303 11.1141 14.3279 11.0106 14.396C10.907 14.464 10.7886 14.5 10.6679 14.5Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.5,
    y1: 4.83333,
    x2: 15.4903,
    y2: 5.46255,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D61D6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7645FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 4.66797,
    y1: 11,
    x2: 11.3334,
    y2: 11.2398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D61D6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7645FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInteractive);
export default __webpack_public_path__ + "static/media/interactive.c131f10933a25e0a53cf90fcda24a029.svg";
export { ForwardRef as ReactComponent };